module.exports = __webpack_public_path__ + "media/images/gifts/movement/sug_movimento_8-aff6b6e58f38cbc823aff17f0755db60.jpg";